import { Country } from "./Country.js";
import { isCountryInEuropeanUnion } from "./utils/isCountryInEuropeanUnion.js";

export function getFathersFamilyMinimumQuantity(country: Country | "outsideEu" | undefined): number {
	if (country === Country.Czechia) {
		return 2;
	}
	return country !== undefined && isCountryInEuropeanUnion(country) ? 4 : Infinity;
}

export function getFathersFamilyDiscountPercentage(
	country: Country | "outsideEu",
	quantity: number,
	weightInGrams: number,
): number {
	const minimumQuantity = getFathersFamilyMinimumQuantity(country);
	if (country === Country.Czechia) {
		return quantity >= minimumQuantity ? 10 : 0;
	}
	if (isCountryInEuropeanUnion(country)) {
		return weightInGrams > 1000 || quantity >= minimumQuantity ? 5 : 0;
	}
	return 0;
}
